<!-- MODAL HEADER-->
<div class="row modal-bar">
  <div class="col-sm-9">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-3">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>


<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">
      <!-- Assignments Active -->
      <div class="row d-flex mb-3">
        <div class="col-lg-6 d-flex align-items-center">
          <div class="mb-0 ckbox">
            <input type="checkbox" [checked]="getShownValue('AssignmentsActive')" [indeterminate]="isIndeterminate('AssignmentsActive')" (click)="updateBooleanValue($event, 'AssignmentsActive')">
            <label class="mb-0 form-check-label">
              <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ASSIGNMENTS-ACTIVE' | translate}}</span>
            </label>
          </div>
        </div>
      </div>
      <!-- Assignment required -->
      <div class="row d-flex mb-3">
        <div class="col-lg-6 d-flex align-items-center">
          <div class="mb-0 ckbox">
            <input type="checkbox" [disabled]="assignmentsDisabled()" [checked]="getShownValue('AssignmentRequired')" [indeterminate]="isIndeterminate('AssignmentRequired')" (click)="updateBooleanValue($event, 'AssignmentRequired')">
            <label class="mb-0 form-check-label">
              <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ASSIGNMENT-REQUIRED' | translate}}</span>
            </label>
          </div>
        </div>
      </div>

      <hr>

        <!-- Allowing invites -->
        <div class="row d-flex mb-3">
          <div class="col-lg-6 d-flex align-items-center">
            <input type="radio" [disabled]="assignmentsDisabled()" name="AllowingInvites" [value]="assignmentEnum.None" [indeterminate]="isIndeterminate('AllowingInvites')" [checked]="getShownValue('AllowingInvites') === assignmentEnum.None" (click)="updateRadioValue($event, 'AllowingInvites')">
            <label class="mb-0 form-check-label ms-2"><span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ALLOWING-INVITES' | translate}}</span></label>
          </div>
          <div class="col-lg-6 d-flex align-items-center">
            <input type="radio" [disabled]="assignmentsDisabled()" name="AllowingInvites" [value]="assignmentEnum.OnlyAllowLinkedAccounts" [indeterminate]="isIndeterminate('AllowingInvites')" [checked]="getShownValue('AllowingInvites') === assignmentEnum.OnlyAllowLinkedAccounts" (click)="updateRadioValue($event, 'AllowingInvites')">
            <label class="mb-0 form-check-label ms-2"><span>{{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ONLY-ALLOW-LINKED-ACCOUNTS' | translate}}</span></label>
          </div>
        </div>

        <!-- Allow view tickets of linked customers -->
        <div class="row d-flex mb-3">
          <div class="col-lg-6 d-flex align-items-center">
            <div class="mb-0 ckbox">
              <input type="checkbox" [disabled]="isDisabled()" [checked]="getShownValue('AllowViewTicketsOfLinkedCustomers')" [indeterminate]="isIndeterminate('AllowViewTicketsOfLinkedCustomers')" (click)="updateBooleanValue($event, 'AllowViewTicketsOfLinkedCustomers')">
              <label class="mb-0 form-check-label">
                <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ALLOW-VIEW-TICKETS-OF-LINKED-CUSTOMERS' | translate}}</span>
              </label>
            </div>
          </div>
        </div>
        <hr>

          <!-- Identification required + reference date -->
          <div class="row d-flex align-items-center mb-3">
            <div class="col-lg-6 d-flex align-items-center">
              <div class="mb-0 ckbox">
                <input type="checkbox" [disabled]="isDisabled()" [checked]="getShownValue('IdentificationRequired')" [indeterminate]="isIndeterminate('IdentificationRequired')" (click)="updateBooleanValue($event, 'IdentificationRequired')">
                <label class="mb-0 form-check-label">
                  <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.IDENTIFICATION-REQUIRED' | translate}}</span>
                </label>
              </div>
            </div>
            @if (getShownValue('IdentificationRequired')) {
              <div class="col-lg-6 d-flex flex-column">
                <span class="mb-1"> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.DESCRIPTION.ID-REFERENCE-DATE' | translate}} </span>
                <input class="form-control" datepicker [beforeToday]="true" [value]="getShownValue('IdentificationReferenceDate')" (change)="updateDateValue($event, 'IdentificationReferenceDate')" [disabled]="isDisabled()" placeholder="DD/MM/YYYY">
              </div>
            }
          </div>

          <!-- Enforce purchasing rights / Check age -->
          <div class="row d-flex mb-3">
            <div class="col-lg-6 d-flex align-items-center">
              <div class="mb-0 ckbox">
                <input type="checkbox" [disabled]="isDisabled()" [checked]="getShownValue('EnforcePurchasingRights')" [indeterminate]="isIndeterminate('EnforcePurchasingRights')" (click)="updateBooleanValue($event, 'EnforcePurchasingRights')">
                <label class="mb-0 form-check-label">
                  <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ENFORCE-PURCHASING-RIGHTS' | translate}}</span>
                </label>
              </div>
            </div>
            <div class="col-lg-6 d-flex align-items-center">
              <div class="mb-0 ckbox">
                <input type="checkbox" [disabled]="isDisabled()" [checked]="getShownValue('CheckAge')" [indeterminate]="isIndeterminate('CheckAge')" (click)="updateBooleanValue($event, 'CheckAge')">
                <label class="mb-0 form-check-label">
                  <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.CHECK-AGE' | translate}}</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Restrict company assignments -->
          <div class="row d-flex mb-3">
            <div class="col-lg-12 d-flex align-items-center">
              <div class="mb-0 ckbox">
                <input type="checkbox" name="RestrictCompanyAssignments" [disabled]="isDisabled()" [checked]="getShownValue('RestrictCompanyAssignments')" [indeterminate]="isIndeterminate('RestrictCompanyAssignments')" (click)="updateBooleanValue($event, 'RestrictCompanyAssignments')">
                <label class="mb-0 form-check-label">
                  <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.RESTRICT-COMPANY-ASSIGNMENTS' | translate}}</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Allow unpaid ticket positions -->
          <div class="row d-flex mb-3">
            <div class="col-lg-6 d-flex align-items-center">
              <div class="mb-0 ckbox">
                <input type="checkbox" [disabled]="isDisabled()"
                  [checked]="getShownValue('AllowUnpaidTicketPositions')"
                  [indeterminate]="isIndeterminate('AllowUnpaidTicketPositions')"
                  (click)="updateBooleanValue($event, 'AllowUnpaidTicketPositions')">
                <label class="mb-0 form-check-label">
                  <span>{{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ALLOW-UNPAID-TICKET-POSITIONS' | translate}}</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Allow unpaid positions -->
          <div class="row d-flex mb-3">
            <div class="col-lg-12 d-flex align-items-center">
              <div class="mb-0 ckbox">
                <input type="checkbox" [disabled]="isDisabled()" [checked]="getShownValue('AllowUnpaidPositions')" [indeterminate]="isIndeterminate('AllowUnpaidPositions')" (click)="updateBooleanValue($event, 'AllowUnpaidPositions')">
                <label class="mb-0 form-check-label">
                  <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ALLOW-UNPAID-POSITIONS' | translate}}</span>
                </label>
              </div>
            </div>
          </div>
          <!-- Allow unpaid positions radio options -->
          @if (getShownValue('AllowUnpaidPositions')) {
            <div class="row d-flex mb-3 py-2" style="background-color: #f5f6f9">
              <div class="col-lg-6 d-flex align-items-center">
                <input type="radio" [disabled]="isDisabled()" name="AllowUnpaidPositionsType" [value]="unpaidAssignmentEnum.OnlyAllowDirectDebit" [indeterminate]="isIndeterminate('AllowUnpaidPositionsType')" [checked]="getShownValue('AllowUnpaidPositionsType') === unpaidAssignmentEnum.OnlyAllowDirectDebit" (click)="updateRadioValue($event, 'AllowUnpaidPositionsType')">
                <label class="mb-0 form-check-label ms-2"><span>{{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ALLOW-UNPAID-DIRECT-DEBIT' | translate}}</span></label>
              </div>
              <div class="col-lg-6 d-flex align-items-center">
                <input type="radio" [disabled]="isDisabled()" name="AllowUnpaidPositionsType" [value]="unpaidAssignmentEnum.All" [indeterminate]="isIndeterminate('AllowUnpaidPositionsType')" [checked]="getShownValue('AllowUnpaidPositionsType') === unpaidAssignmentEnum.All" (click)="updateRadioValue($event, 'AllowUnpaidPositionsType')">
                <label class="mb-0 form-check-label ms-2"><span>{{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.ALLOW-UNPAID-ALL-POSITIONS' | translate}}</span></label>
              </div>
            </div>
          }

          <!-- C3V Blacklist check -->
          @if (C3VIsEnabled) {
            <div class="row d-flex align-items-center mb-3">
              <div class="col-lg-6 d-flex align-items-center">
                <div class="mb-0 ckbox">
                  <input type="checkbox" name="BlacklistCheck" [disabled]="isDisabled()" [checked]="getShownValue('BlacklistCheck')" [indeterminate]="isIndeterminate('BlacklistCheck')" (click)="updateBooleanValue($event, 'BlacklistCheck')">
                  <label class="mb-0 form-check-label">
                    <span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.BLACKLIST-CHECK.C3V' | translate}}</span>
                  </label>
                </div>
              </div>
            </div>
          }
          <!-- C3V Blacklist check options -->
          @if (C3VIsEnabled && getShownValue('BlacklistCheck')) {
            <div class="row d-flex mb-3 py-2" style="background-color: #f5f6f9">
              <div class="col-lg-6 d-flex align-items-center">
                <input type="radio" name="C3VBlacklistCheck" [disabled]="isDisabled()" [value]="AssignmentPolicyC3VSettingEnum.A" [indeterminate]="isIndeterminate('C3VBlacklistCheck')" [checked]="getShownValue('C3VBlacklistCheck') === AssignmentPolicyC3VSettingEnum.A" (click)="updateRadioValue($event, 'C3VBlacklistCheck')">
                <label class="mb-0 form-check-label ms-2"><span> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.BLACKLIST-CHECK.C3VA' | translate}}</span></label>
              </div>
              <div class="col-lg-6 d-flex align-items-center">
                <input type="radio" name="C3VBlacklistCheck" [disabled]="isDisabled()" [value]="AssignmentPolicyC3VSettingEnum.BC" [indeterminate]="isIndeterminate('C3VBlacklistCheck')" [checked]="getShownValue('C3VBlacklistCheck') === AssignmentPolicyC3VSettingEnum.BC" (click)="updateRadioValue($event, 'C3VBlacklistCheck')">
                <label class="mb-0 form-check-label ms-2"><span>{{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.BLACKLIST-CHECK.C3VBC' | translate}}</span></label>
              </div>
            </div>
          }


          <hr>

            <!-- Revoke Period -->
            <div class="row d-flex align-items-start">
              <div class="col-lg-12 d-flex">
                <h6 class="form-header h6-icon">
                  {{ 'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.HEADER.REVOKE-PERIOD' | translate }}
                </h6>
              </div>
              <div class="col-lg-6 d-flex flex-column">
                <span class="mb-2 d-block" style="color: #8a909d; font-size: 14px;"> {{'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.DESCRIPTION.REVOKE-PERIOD' | translate}} </span>
                <t4-timespan-control #timeSpanControl formControlName="RevokeTimeSpan" [RevokeTimeSpan]="isIndeterminate('RevokeTimeSpan') ? '0.00:00:00' : getShownValue('RevokeTimeSpan')" [labelTimeSpan]="'DIALOGS.EDIT-ASSIGNMENT-POLICY-FORM.LABEL.REVOKE-PERIOD'" [indeterminate]="isIndeterminate('RevokeTimeSpan')" (changeEvent)="revokedTimeSpanChanged()"></t4-timespan-control>
                <t4-display-validation controlName="RevokeTimeSpan" [form]="form" [messages]="validationMessages"></t4-display-validation>
              </div>
            </div>

            <div class="form-layout-footer row d-flex pt-4">
              <div class="col-6">
                <t4-lro-button (onLROClick)="submit()" [isDisabled]="!isDirty || saving || form.invalid" [lroTypeCode]="longRunningOperationTypeEnum.UpdateTicketAssignmentPolicies"
                cssClasses="btn btn-block btn-primary bd-0" [icon]="'far fa-save'" [text]="'GENERIC.BUTTON.SAVE'"></t4-lro-button>
              </div>
              <div class="col-6">
                <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0"><i
                  class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
                </div>
              </div><!-- form-layout-footer -->
            </div><!-- form-layout -->
          </div>
        </form>
